// extracted by mini-css-extract-plugin
export default {"questions":"Sections-module__questions__1HNnv","question":"Sections-module__question__Yx8pr","sectionTitle":"Sections-module__sectionTitle__HdIyU"};